/**
 * theme.js — design tokens, ported 1:1 from the mobile app's src/theme.js so
 * brand colours stay identical across app, web and admin.
 * Values are also emitted as CSS custom properties in styles.css.
 */

export const colors = {
  primary: '#C1121F',
  primaryDark: '#9A0E18',
  primaryLight: '#E63946',
  primarySoft: '#FDECEE',

  accent: '#E8A33D',
  accentSoft: '#FCF3E2',

  success: '#1E9E6A',
  warning: '#E0930B',
  danger: '#D7263D',
  info: '#2D6CDF',

  bg: '#F6F7FB',
  surface: '#FFFFFF',
  border: '#ECEDF2',

  text: '#1B1D28',
  textMuted: '#6B6F80',
  textFaint: '#9AA0B0',
  white: '#FFFFFF',
};

export const radius = { sm: 8, md: 12, lg: 18, xl: 24, pill: 999 };

// Category tints, cycled in the same order the app uses.
export const TINTS = ['#FDECEE', '#FCF3E2', '#E7EFFC', '#E5F5EE', '#FBE6E9', '#F3ECFB'];

export const rupee = (n) => '₹' + Number(n || 0).toLocaleString('en-IN');

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

const theme = { colors, radius, TINTS, rupee, fmtDate };
export default theme;
